import {Component, OnInit} from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {AppMainComponent} from './app.main.component';
import {PrimeIcons} from 'primeng/api';
import {AppComponent} from 'src/app/app.component';
import {UserService} from "../../services/user.service";

export interface Menu {
  label: string;
  items?: Menu[];
  icon?: string;
  routerLink?: string[];
  roles?: string[];
}

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  animations: [
    trigger('inline', [
      state('hidden', style({
        height: '0px',
        overflow: 'hidden'
      })),
      state('visible', style({
        height: '*',
      })),
      state('hiddenAnimated', style({
        height: '0px',
        overflow: 'hidden'
      })),
      state('visibleAnimated', style({
        height: '*',
      })),
      transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class AppMenuComponent implements OnInit {

  private model: Menu[];

  constructor(
    public app: AppComponent,
    public appMain: AppMainComponent,
    private userService: UserService
  ) {
  }

  ngOnInit() {

    let roles = this.userService.getRoles();

    let items: Array<any> = []
    if (this.userService.canEdit()) {
      items.push({label: 'Créer un projet', icon: PrimeIcons.BOOK, routerLink: ['/ouvrage/creation']})
    }
    items.push({label: 'Éditer des ressources numériques', icon: PrimeIcons.FILE_EDIT, routerLink: ['/ouvrage/liste']})
    items.push({label: 'Recherche', icon: PrimeIcons.FILE_EDIT, routerLink: ['/ressources_numeriques_liste']})

    if (roles.includes('SUPER_CEM')) {
      items.push({label: 'Miniliens', icon: PrimeIcons.LINK, routerLink: ['/miniliens']})
    }

    this.model = [
      {
        label: 'Administration', items: items
      },
    ];

  }

  onMenuClick(event) {
    this.appMain.onMenuClick(event);
  }

  getModel(): any[] {
    return this.model;
  }
}
